<template>
  <van-pull-refresh
    v-model="refreshing"
    class="consultation-list-container"
    @refresh="handleRefresh"
  >
    <van-cell-group v-for="(consultation) in consultationList" :key="consultation.id">
      <van-cell>
        <div style="float:left;margin-right:3px;">
          <van-icon name="question" color="#1d953f" />
        </div>
        <div> 问：{{ consultation.question }}</div>
      </van-cell>
      <van-cell>
        <div style="float:left;margin-right:3px;">
          <van-icon name="checked" color="#f58220" />
        </div>
        <div>
          答：
          <span v-if="consultation.answer"> {{ consultation.answer }}</span>
          <span v-else>暂未回复</span>
        </div>
      </van-cell>
    </van-cell-group>
    <!-- 用来占位 -->
    <div style="height:50px;" />
    <van-button icon="plus" type="primary" size="large" style="position:fixed;bottom:0px;" to="/other/consultationAdd">
      在线咨询
    </van-button>
  </van-pull-refresh>
</template>

<script type="text/javascript">
import { getConsultationList } from '@/api/other'
import { Toast } from 'vant'

export default {
  components: {},
  data() {
    return {
      refreshing: false,
      consultationList: []
    }
  },
  mounted() {
    this.loadConsultationList()
  },
  methods: {
    loadConsultationList() {
      const webUserId = this.$store.getters.webUserInfo.id // 用户id
      if (!webUserId) { return }
      return new Promise((resolve, reject) => {
        getConsultationList({ webUserId: webUserId }).then(({ data }) => {
          this.consultationList = data
          resolve(data)
        }).catch(error => {
          // 设置列表加载失败
          this.error = true
          reject(error)
        })
      })
    },
    handleRefresh() {
      this.refreshing = true
      this.loadConsultationList().then().finally(() => {
        this.refreshing = false
        Toast.success('刷新成功')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.consultation-list-container{
  background-color: #eee;
   min-height: 100vh;
}
</style>
